import React from 'react';
import { Chip, ChipProps } from '@mui/material';

interface CMChipProps extends Omit<ChipProps, 'color'> {
  colorScheme?: 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'info' | 'default';
}

export const CMChip: React.FC<CMChipProps> = ({ 
  colorScheme = 'secondary',
  sx,
  ...props 
}) => {
  const getColorStyles = (scheme: NonNullable<CMChipProps['colorScheme']>) => {
    const colorMap = {
      primary: {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
      },
      secondary: {
        backgroundColor: 'secondary.main',
        color: 'white',
      },
      error: {
        backgroundColor: 'error.main',
        color: 'error.contrastText',
      },
      warning: {
        backgroundColor: 'warning.main',
        color: 'warning.contrastText',
      },
      success: {
        backgroundColor: 'success.main',
        color: 'success.contrastText',
      },
      info: {
        backgroundColor: 'info.main',
        color: 'info.contrastText',
      },
      default: {
        backgroundColor: '#ffd899df',
        color: 'black',
      },
    } as const;

    return colorMap[scheme];
  };

  return (
    <Chip
      {...props}
      sx={{
        borderRadius: '4px',
        margin: 5,
        fontSize: '0.875rem',
        height: '28px',
        px: 10,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        '& .MuiChip-label': {
          px: 2, // More horizontal padding for the text
          py: 1.5, // More vertical padding
        },
        '&:hover': {
          opacity: 0.9,
          boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
        },
        ...getColorStyles(colorScheme),
        ...sx
      }}
    />
  );
}; 